export default __webpack_public_path__ + "9d0ac3791032a3968c67ef34500fde01.webp";